import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ISbStoriesParams } from '@storyblok/js';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
    selector: 'app-card',
    imports: [
        CommonModule,
        RouterModule,
        DynamicModule,
        StoryblokLinkDirective,
        StoryblokDirective,
        StoryblokRichTextDirective,
        NgOptimizedImage,
    ],
    templateUrl: './card.component.html',
    styleUrls: ['./card.component.scss']
})
export class CardComponent implements OnInit {
  @Input() name!: string;
  @Input() link!: any;
  @Input() linktext!: any;
  @Input() image!: ISbStoriesParams;
  @Input() _editable!: string;
  @Input() content: any;
  @Input() _uid!: string;
  @Input() component!: string;

  ngOnInit() {}
}
